import { SwitchView } from './components';
import React, { useState } from 'react';
export function Switch({ left, right, ariaLabel, defaultTogglePosition = 'left', onChange, theme }) {
    const [togglePosition, setTogglePosition] = useState(defaultTogglePosition);
    function selectTogglePosition(selectedTogglePosition) {
        if (selectedTogglePosition !== togglePosition) {
            setTogglePosition(selectedTogglePosition);
            if (onChange) {
                onChange(selectedTogglePosition === 'left' ? left.value : right.value);
            }
        }
    }
    return (React.createElement(SwitchView, { left: left, right: right, togglePosition: togglePosition, onSelectTogglePosition: selectTogglePosition, ariaLabel: ariaLabel, theme: theme }));
}
//# sourceMappingURL=switch.js.map